// extracted by mini-css-extract-plugin
export default {"bg":"UnsecuredBL_bg__BJncE","main":"UnsecuredBL_main__gOcwJ","left":"UnsecuredBL_left__+vFBc","right":"UnsecuredBL_right__XxwKb"};